// extracted by mini-css-extract-plugin
export default {"defaultValueWarning":"ActivityTypeWarning_defaultValueWarning__m+oWw"};